<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      size="mini"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 24 }" :lg="{ span: 8 }">
          <el-form-item
            :label="$l('table_head_colorName') || '颜色名称'"
            prop="colorName"
          >
            <el-input
              clearable
              v-model="formData.colorName"
              size="mini"
              :placeholder="
                $l('table_head_please_input_colorName') || '请输入颜色名称'
              "
              maxlength="200"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 24 }" :lg="{ span: 8 }">
          <el-form-item
            :label="$l('table_head_colorNameEn') || '颜色名称英文'"
            prop="colorNameEn"
          >
            <el-input
              clearable
              v-model="formData.colorNameEn"
              size="mini"
              maxlength="200"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 24 }" :lg="{ span: 8 }">
          <el-form-item
            :label="$l('table_head_mainColor') || '色系'"
            prop="mainColor"
          >
            <dict-select
              clearable
              v-model="formData.mainColor"
              filterable
              size="mini"
              :placeholder="
                $l('table_head_please_select_color') || '请选择色系'
              "
              url="/master/master/color/main/color"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 24 }" :lg="{ span: 8 }">
          <el-form-item
            :label="$l('table_label_isCustomer') || '是否客户颜色'"
            prop="isCustomer"
          >
            <el-select
              v-model="formData.isCustomer"
              size="mini"
              style="width: 100%"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              @change="isCustomerChange"
            >
              <el-option
                key="Y"
                :label="$l('table_label_isCustomer_Y') || '是'"
                value="Y"
              >
              </el-option>
              <el-option
                key="N"
                :label="$l('table_label_isCustomer_N') || '否'"
                value="N"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 24 }" :lg="{ span: 8 }">
          <el-form-item
            :label="$l('table_label_brand') || '品牌'"
            prop="brandCode"
          >
            <dict-select
              clearable
              v-model="formData.brandCode"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              filterable
              size="mini"
              url="/master/common/dict/brandSelect"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 24 }" :lg="{ span: 8 }">
          <el-form-item
            :label="$l('table_head_colorCard') || '色号'"
            prop="colorCard"
          >
            <br />
            <el-color-picker
              v-model="formData.colorCard"
              :predefine="predefineColors"
            ></el-color-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item :label="$l('form_label_remarks') || '备注说明'">
            <el-input
              v-model="formData.remark"
              :placeholder="
                $l('form_label_pe_input_remarks') || '请输入备注说明'
              "
              maxlength="500"
              show-word-limit
              clearable
              type="textarea"
              :rows="3"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col
          :sm="{ span: 24 }"
          :md="{ span: 6 }"
          :lg="{ span: 12 }"
          v-if="disabled"
        >
          <el-form-item
            :label="$l('INDEX.creator') || '创建人'"
            prop="createByName"
          >
            <el-input
              clearable
              size="mini"
              v-model="formData.createByName"
              :placeholder="
                $l('INDEX.form_label_automatic_system_generation') ||
                  '不需要输入，由系统生成'
              "
              :disabled="true"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col
          :sm="{ span: 24 }"
          :md="{ span: 6 }"
          :lg="{ span: 12 }"
          v-if="disabled"
        >
          <el-form-item
            :label="$l('INDEX.create_date') || '创建时间'"
            prop="createDate"
          >
            <el-input
              clearable
              size="mini"
              v-model="formData.createDate"
              :placeholder="
                $l('INDEX.form_label_automatic_system_generation') ||
                  '不需要输入，由系统生成'
              "
              :disabled="true"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col
          :sm="{ span: 24 }"
          :md="{ span: 6 }"
          :lg="{ span: 12 }"
          v-if="disabled"
        >
          <el-form-item
            :label="$l('INDEX.table_label_modified_by') || '修改人'"
            prop="modifyByName"
          >
            <el-input
              clearable
              size="mini"
              v-model="formData.modifyByName"
              :placeholder="
                $l('INDEX.form_label_automatic_system_generation') ||
                  '不需要输入，由系统生成'
              "
              :disabled="true"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col
          :sm="{ span: 24 }"
          :md="{ span: 6 }"
          :lg="{ span: 12 }"
          v-if="disabled"
        >
          <el-form-item
            :label="$l('INDEX.table_label_modification_date') || '修改时间'"
            prop="modifyDate"
          >
            <el-input
              clearable
              size="mini"
              v-model="formData.modifyDate"
              :placeholder="
                $l('INDEX.form_label_automatic_system_generation') ||
                  '不需要输入，由系统生成'
              "
              :disabled="true"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'

export default {
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    colorCode: String,
    params: { type: Object, default: () => {} },
  },
  data() {
    return {
      formData: { colorStatus: 'Y', isCustomer: 'N' },
      predefineColors: [
        '#FFA500',
        '#FFFFFF',
        '#800080',
        '#FF0000',
        '#008000',
        '#0000FF',
        '#FFFF00',
        '#000000',
      ],
    }
  },
  mounted() {
    this.getData()
  },
  computed: {
    rules() {
      return {
        colorName: [
          {
            required: true,
            message:
              this.$l('table_head_please_input_colorName') || '请输入颜色名称',
            trigger: 'blur',
          },
        ],
        mainColor: [
          {
            required: true,
            message: this.$l('table_head_please_select_color') || '请选择色系',
            trigger: 'blur',
          },
        ],
        colorNameEn: [
          {
            required: true,
            message:
              this.$l('table_head_please_input_colorName') || '请输入颜色名称',
            trigger: 'blur',
          },
        ],
        brandCode: [
          {
            required: this.formData.isCustomer != 'N',
            message: this.$l('table_label_please_select_brand') || '请选择品牌',
            trigger: 'blur',
          },
        ],
      }
    },
  },
  methods: {
    isCustomerChange() {
      if (this.formData.isCustomer != 'Y') {
        this.formData.brandCode = ''
      }
    },
    getData() {
      if (!this.colorCode) return

      this.$api
        .masterColorDetailApi({
          colorCode: this.colorCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }
      this.loadingOpen()
      this.$api
        .masterColorSaveApi(this.formData)
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.openQuestion()
    },
    close() {
      this.$emit('close')
    },
    openQuestion() {
      this.$confirm(
        this.$l('INDEX.tips_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_save') || '保存',
          cancelButtonText: this.$l('INDEX.btn_no_save') || '不保存',
        }
      )
        .then(() => {
          this.save()
        })
        .catch((action) => {
          if (action === 'cancel') {
            this.close()
          }
        })
    },
  },
}
</script>
